import { driverAvailabilityLabels } from '../../../data/drivers'
import type { DriverAvailability } from '../../../types'
import { cn } from '../../../utils/cn'

/** The design only draws three states; On Break borrows the neutral treatment. */
const STYLES: Record<DriverAvailability, string> = {
  available: 'bg-dash-avail-on text-dash-avail-on-ink',
  'on-trip': 'bg-dash-avail-trip text-dash-pill-ontrip-ink',
  'on-break': 'bg-dash-pill-unpaid text-dash-avail-on-ink',
  offline: 'bg-dash-avail-off text-dash-avail-off-ink',
}

type AvailabilityBadgeProps = {
  availability: DriverAvailability
}

export const AvailabilityBadge = ({ availability }: AvailabilityBadgeProps) => (
  <span
    className={cn(
      'flex h-[22px] shrink-0 items-center justify-center whitespace-nowrap rounded-[12px] px-[10px] font-host text-[12px] font-semibold leading-normal',
      STYLES[availability],
    )}
  >
    {driverAvailabilityLabels[availability]}
  </span>
)
